import React from 'react'
import { BsLinkedin } from 'react-icons/bs';
import { FaGithub } from 'react-icons/fa';
import { GrInstagram } from 'react-icons/gr';

const HeaderSocials = () => {
  return (
    <div className="header__socials fade-in">
            <a href='https://linkedin.com/in/abilio-aragao' target="_blank" rel='noreferrer'><BsLinkedin /></a>
            <a href='https://github.com/abilio-aragao' target="_blank" rel='noreferrer'><FaGithub /></a>
            <a href='https://instagram.com/abilio_aragao' target="_blank" rel='noreferrer'><GrInstagram /></a>
          </div>
  )
}

export default HeaderSocials